// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2yeyT","lowLoad":"style_lowLoad__SpdCT"};